var _rect, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbbEmptyLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 59.56 59.56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.43,
    y: 5.71,
    width: 48.4,
    height: 48.4,
    rx: 3,
    stroke: "#333333",
    strokeWidth: 2.667
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 17.22,
    x2: 51.83,
    y2: 17.22,
    stroke: "#333333",
    strokeWidth: 2.667
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19.27,
    y1: 26.55,
    x2: 40.27,
    y2: 26.55,
    stroke: "#333333",
    strokeWidth: 3.174,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12.48,
    y1: 33.22,
    x2: 47.08,
    y2: 33.22,
    stroke: "#333333",
    strokeWidth: 3.174,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19.27,
    y1: 39.89,
    x2: 40.27,
    y2: 39.89,
    stroke: "#333333",
    strokeWidth: 3.174,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbbEmptyLabel);
export default __webpack_public_path__ + "static/media/tbb-empty-label.eb008abf5e22d27190d9c4b604e14062.svg";
export { ForwardRef as ReactComponent };